import { getAlignedPackageSpec } from './get-aligned-package-spec.js'

export function getAlignedDeclaredDependencies(packageNames: string[]): string[] {
  return packageNames.flatMap((name) => {
    const alignedSpec = getAlignedPackageSpec(name)
    return alignedSpec ? [alignedSpec] : []
  })
}
